import { subjects } from './exampleProjects.js';


(function () {
    function renderExamples(selectedSubject) {
        selectedSubject = subjects[selectedSubject];
        const exampleProjects = $('.js-example-project');
        const exampleProjectsLength = exampleProjects.length;

        for (let i = 0; i < exampleProjectsLength; i++) {
            const project = exampleProjects[i];
            const projectContent = selectedSubject.projects[i];

            $(project).attr('href', projectContent.projectLink);
            $(project).find('.example-project-class').html(projectContent.classroom);
            $(project).find('.example-project-item').html(projectContent.item);
            $(project).find('.example-project-testimonial p').html('&ldquo;' + projectContent.quote + '&rdquo;');
            $(project).find('.example-project-photo-wrapper').css('background-position', projectContent.spritePosition);
        }
    }

    function attachExamplesListener() {
        $('body').on('click', '.js-example-project-link', function (e) {
            e.preventDefault();
            $('.js-example-project-link').removeClass('active');
            $(this).addClass('active');

            const selectedSubject = $(this).data('subject');
            renderExamples(selectedSubject);
        });
    }

    $(function () {
        renderExamples(0);
        attachExamplesListener();
    });
})();
